<template>
  <div id="app">
    <!-- <img src="https://imgs.hdjfg.com/gift/img/login_bg.png" class="header-img" /> -->
    <div class="station_top"></div>
    <div class="login-page ">
      <div class="font-weight-bold  font-18 line-height-23 welcome text-center"> Welcome to Login</div>
      <div class="input-box flex flex-align-center F6F6F6-back margin-top-36  margin-bottom-18">
        <van-icon name="https://imgs.hdjfg.com/gift/img/phone.png" size="20" class="margin-right-20" />
        <input type="text" placeholder="Fill in mobile number" class="common-input" v-model="phone" />
      </div>
      <div class="input-box flex flex-align-center F6F6F6-back margin-bottom-16">
        <van-icon name="https://imgs.hdjfg.com/gift/img/code.png" size="20" class="margin-right-20" />
        <input type="text" placeholder="Code" v-model="code" class="common-input flex-1" />
        <div v-if="send" class="common-btn_login font-12 placeholder-back white placeholder-border">{{ remainingSeconds
        }}s</div>
        <div v-else class="common-btn_login font-16 font-weight-bold  theme" @click="sendCode">Code</div>
      </div>
      <div v-if="send && code"
        class="login-btn font-16 flex font-weight-bold flex-align-center flex-justify-center margin-top-45  theme-back white"
        @click="login">
        LOGIN
      </div>
      <div v-else
        class="login-btn font-16 flex font-weight-bold flex-align-center flex-justify-center margin-top-45 disable theme-back white">
        LOGIN
      </div>
    </div>
  </div>
</template>

<script>
!function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ?
      n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s)
}(window, document, 'script',
  'https://connect.facebook.net/en_US/fbevents.js');
export default {
  data() {
    return {
      remainingSeconds: 0,
      send: false,
      phone: '',
      code: '',
      parameters: {}
    }
  },
  created() {
    let od = window.location.href.split("?")[1];
    if (od) {
      this.parameters = this.parameter(od);
    }
    let channel = window.localStorage.getItem('channel')
    if (channel) {
      this.parameters.channel = channel;
    }
  },
  methods: {
    getnavigator() {
      var u = navigator.userAgent
      let navigators = {
        trident: u.indexOf('Trident') > -1,//IE内核 
        presto: u.indexOf('Presto') > -1, //opera内核 
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核 
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核 
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),//是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),//ios终端 
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器 
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器 
        iPad: u.indexOf('iPad') > -1, //是否iPad 
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部 
        weixin: u.indexOf('MicroMessenger') > -1,//是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq" //是否QQ 
      }
      let type = 0;
      for (let key in navigators) {
        if (navigators[key] == true) {
          type++
        }
      }
      return type > 0 ? true : false;
    },
    parameter(data) {
      let arr = data.split("&")
      console.log(arr)
      let argument = {};
      for (var i = 0; i < arr.length; i++) {
        argument[arr[i].split("=")[0]] = arr[i].split("=")[1]
      }
      return argument
    },
    async sendCode() {
      /*       if (!this.isPhoneValid(this.phone)) {
              this.$toast('手机号格式错误')
              return
            } */
      const { data: res } = await this.$http.post('/api/code/index', {
        phone: this.phone,
        code_type: 'Login'
      })
      this.loading = true
      if (res.code === 0) {
        var that = this
        this.$toast('code success!')
        this.remainingSeconds = 60
        this.send = true
        var countdownTimer = setInterval(function () {
          var remainingSeconds = that.remainingSeconds
          that.remainingSeconds = remainingSeconds - 1
          console.log(that.remainingSeconds)
          if (that.remainingSeconds === 0) {
            // 倒计时结束，重新启用发送验证码的按钮
            clearInterval(countdownTimer)
            that.send = false
          }
        }, 1000)
      } else {
        this.$toast(res.msg)
      }
    },
    async login() {
      if (!this.phone) {
        this.$toast('phone is empty')
        return
      }
      if (!this.code) {
        this.$toast('code is empty')
        return
      }
      let channel = 'h5'
      if (this.parameters.channel) {
        channel = this.parameters.channel
      }
      let is_pd = this.getnavigator();
      if (is_pd == false) {
       channel = '';
      }
      const { data: res } = await this.$http.post('/api/login/code', {
        phone: this.phone,
        code: this.code,
        channel: channel
      })
      if (res.code === 0) {
        window.localStorage.setItem('channel', null)
        window.localStorage.setItem('token', res.data.token);
        if (res.data.is_reg == 1) {
          fbq('init', res.data.channel_fbq);
          fbq('track', 'PageView');
          fbq('track', 'CompleteRegistration');
        }


        this.$router.push({
          name: 'index'
        })
      } else {
        this.$toast(res.msg)
      }
    },
    isPhoneValid(phoneNumber) {
      var regex = /^1[3-9]\d{9}$/
      return regex.test(phoneNumber)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: url('https://imgs.hdjfg.com/gift/img/login_bg.png') no-repeat;
  background-size: 100%;
  background-color: #FFA775;
  min-height: 100vh;
  padding: 20px 0px 0px 0px;
  box-sizing: border-box;

  .welcome {
    font-family: HelveticaNeue-Bold, HelveticaNeue;
  }

  .header-img {
    width: 100%;
  }

  .station_top {
    height: 142px;
  }

  .login-page {
    background: #FFFFFF;
    border-radius: 14px;
    padding: 24px 20px;
    position: relative;
    margin: 0 18px;
  }

  .common-input {
    width: 100%;
    border: 0 !important;
    outline: none !important;
    background: transparent;
  }

  .input-box {
    width: 100%;
    height: 44px;
    border-radius: 26px;
    border: 1px solid #fff5eb;
    box-sizing: border-box;
    padding: 0 16px;
  }

  .common-btn_login {
    padding: 4px 8px;
    border-radius: 20px;
  }

  .login-btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    box-sizing: border-box;
  }

  .select-icon {
    width: 17px;
    height: 17px;
    border-radius: 50%;
  }

  .disable {

    opacity: 0.5;
  }
}
</style>
